import React from 'react';
import { useLocation } from 'react-router';

import { GuestMobileNav, HamburgerButton, MobileDrawer } from 'components/MobileDrawer';
import { useIsMobileLayout } from 'hooks/useMediaQuery';
import logo from 'assets/images/logotype/Logo_Stand_Red.svg';
import { marketingLinks } from 'utils/siteLinks';

import styles from './HeaderError.module.scss';

const HeaderLogo = () => {
  return (
    <a
      href={marketingLinks.home}
      className={styles['header-logo']}
      aria-label='MyTeacher.pro - на главную'
    >
      <img src={logo} alt='' />
      <div className={styles['header-logo__content']}>
        <h4>MYTEACHER</h4>
        <span>PRO</span>
      </div>
    </a>
  );
};

const HeaderContent = () => {
  return (
    <div className={styles['header-content']}>
      <span>Личный кабинет</span>
    </div>
  );
};

// Figma 18:3826 «Шапка гостя»: 1440 - «Личный кабинет», 768 и 360 - кнопка «Меню».
export const HeaderError = () => {
  const isMobile = useIsMobileLayout();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = React.useState(false);

  React.useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={styles.header}>
      <div className={styles['header-wrapper-content']}>
        <HeaderLogo />
        {isMobile ? (
          <HamburgerButton open={menuOpen} onClick={() => setMenuOpen((prev) => !prev)} />
        ) : (
          <HeaderContent />
        )}
      </div>
      {isMobile && (
        <MobileDrawer open={menuOpen} onClose={closeMenu} title='Меню' accent='guest'>
          <GuestMobileNav onNavigate={closeMenu} />
        </MobileDrawer>
      )}
    </header>
  );
};
